<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
<div class="container-fluid">
  <p-confirmDialog class="confirm-message-popup" appendTo="body"></p-confirmDialog>
  <p-confirmDialog key="warning" appendTo="body"></p-confirmDialog>
  <div class="row">
    <div class="col-12 flex p-0">
      <div class="col-3">
          <div class="row m-0 p-0">
            <div class="col-11" id="multiselectDiv">
              <div class="ui-inputgroup mb-0" id="filterLabel">
                <button pButton class="theme-button noHover labelButton" type="button" label="Filter"></button>
                <p-multiSelect [options]="beadChipFilterOptions" (onChange)="onApplyBeadChipFilter()" [(ngModel)]="selectedBeadChipStatuses" id="multiselectStatuses"
                 [maxSelectedLabels]="1" placeholder="Sel. Status" styleClass="multiSelectionDropdown">
                  <ng-template let-filterItem pTemplate="selectedItem">
                    <span style="vertical-align:middle">{{filterItem.label}}</span>
                  </ng-template>
                  <ng-template let-beadChipStatus pTemplate="filterItem">
                    {{beadChipStatus.label}}
                  </ng-template>
                </p-multiSelect>
              </div>
            </div>

            <div class="col-1" id="refreshBatchesDiv">
              <button pButton class="refreshBatches" *ngIf="checkBeadChipTabActive()" icon="fa fa-refresh" (click)="reloadBeadChipTable()"></button>
            </div>
          </div>
          <div class="row m-0 p-0">
            <div class="col-11 pt-2" id="multiselectDiv">
              <div class="ui-inputgroup mb-0" id="filterLabel">
                <button pButton class="theme-button noHover labelButton" type="button" label="Workflow"></button>
                <p-multiSelect [options]="plateWorkFlowList" name="workFlowList" (onChange)="onApplyBeadChipFilter()" [(ngModel)]="selectedPlateWorkflows" 
                  id="multiselectStatuses" placeholder="Sel. Workflow" styleClass="multiSelectionDropdown">
                  <ng-template let-workFlowItem pTemplate="selectedItem">
                    <span style="vertical-align:middle">{{workFlowItem.label}}</span>
                  </ng-template>
                  <ng-template let-workFlow pTemplate="workFlowItem">
                    {{workFlow.label}}
                  </ng-template>
                </p-multiSelect>
              </div>
            </div>

            <div class="col-1 pt-2" id="refreshBatchesDiv">
              <button pButton icon="pi pi-times" class="refreshBatches resetButton" (click)="resetAllBeadChipFilter()"></button>
            </div>
          </div>
          <div class="row m-0 p-0">
            <div class="col-11 pt-2" id="multiselectDiv">
              <div class="ui-inputgroup" id="datePicker">
                <button pButton class="theme-button noHover labelButton" type="button" label="Date"></button>
                <p-calendar [(ngModel)]="beadChipFromDate" readonlyInput="true" (onSelect)="onApplyBeadChipFilter()"
                  dateFormat="dd.mm.yy" [showIcon]="true" placeholder="Sel. Start Date" showButtonBar="true"
                  (onClearClick)="onApplyBeadChipFilter()" (onTodayClick)="onApplyBeadChipFilter()">
                </p-calendar>
              </div>
            </div>
          </div>
      </div>
      <div class="col-9">
        <div class="col-12 flex" id="topGroup">

          <div class="col-4 topDivspacing pr-0" id="topDiv">
              <div class="ui-inputgroup" id="inputClass">
                <button pButton class="theme-button noHover labelButton" type="button" label="User ID"></button>
                <input pInputText name="UserPUID" [(ngModel)]="puid" size="10" id="userID" maxlength="4" id="puid-field" />
                <button pButton class="search-field-blue-end"></button>
              </div>
              <div class="ui-inputgroup" id="inputClass">
                <button pButton class="theme-button noHover labelButton" type="button" label="Beadchip ID"></button>
                <input pInputText name="SearchBeadChip" [(ngModel)]="beadChipToSearch" size="10" (keydown.enter)="searchForBeadChip()"/>
                <button pButton class="search-field-blue-end" icon="fa fa-search" (click)="searchForBeadChip()"></button>
              </div>
              <div class="ui-inputgroup" id="inputClass">
                <button pButton class="theme-button noHover labelButton" type="button" label="Sample ID"></button>
                <input pInputText name="SearchSample" [(ngModel)]="sampleToSearch" size="10" (keydown.enter)="searchForSample()"/>
                <button pButton class="search-field-blue-end" icon="fa fa-search" (click)="searchForSample()"></button>
              </div>
            </div>

            <div class="col-4 topDivspacing pl-0 pr-0" style="text-align:left;">
              <div class="col-12 flex headers">
                <h5>
                  Beadchip: <strong>{{selectedBeadChipPlate?.plateID}} </strong>
                </h5>
              </div>
              <div class="col-12 flex headers statusField" id="headerNonTop">
                <h5>
                  Status: <strong> {{selectedBeadChipPlate?.status}} </strong>
                </h5>
              </div>
              <div class="col-12 flex headers" id="headerNonTop">
                <h5>
                  Sender:<strong> {{selectedBeadChipPlate?.sender}}</strong>
                </h5>
              </div>
              <div class="col-12 flex headers" id="headerNonTop" style="margin-top:-14px">
                <h5>
                  Storage:<strong> </strong>
                </h5>
              </div>
            </div>

          <div class="col-4 topDivspacing pl-0">
            <div class="col-12 flex p-0">
              <div class="col-7 p-0">
                <button pButton icon="fa fa-list-alt" label="View Beadchips" (click)="toggleBeadChipView()" class="buttonsRound" id="plateView" (click)="fetchDataForPlateView()" *ngIf="selectedBeadChipPlate?.plateID"></button>
              </div>
              <div class="col-7 p-0">
                <button pButton icon="fa fa-comment" label="Comments" *ngIf="selectedBeadChipPlate?.plateID"
                (click)="showComments()" class="buttonsRound" id="plateView">
                  </button>
              </div>
              <div class="col-5 p-0">
                <button pButton icon="fa fa-comment" label="Comments" *ngIf="lastUpdatedBeadChips1.length>0 && this.multiBeadChip"
                  (click)="showMultiComments()" class="buttonsRound" id="plateView">
                </button>
              </div>
            </div>
            <div class="col-9 p-0 ui-inputgroup" id="log-upload-div">
              <input #manualfileUpload pInputText class="form-control" name="profile" type="file"
                accept=".log" (change)="onFileSelect($event)" id="fileChooser" placeholder="Upload Log Files"
                #fileInput />
              <button pButton icon="fa fa-upload" type="submit" id="uploadButtonExcel"
                (click)="fileUpload()" [disabled]="isFileNotSelected" class="uploadBtn">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 flex p-0">
      <div class="col-3">
        <div class = "tableLHS1">
          <p-table [value]="beadchipPlates" [(selection)]="tableSelectedRow" selectionMode="single" (onRowSelect)="fetchBeadchip($event)" (onRowUnselect) ="removeBeadChipSelection()" [loading]="loading">
            <ng-template pTemplate="header">
              <tr >
                <th scope="col" class="batch">BeadChip ID</th>
                <th scope="col" class="status">Status</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-beadchip>
              <tr style="border: 1px solid lightgray;" [pSelectableRow]="beadchip">

                <td style="width: 35%; border: 1px solid lightgray;" class="normalBody pr-0">
                  {{beadchip?.plateID}}</td>
                <td style="width: 65%;border: 1px solid lightgray;" class="normalBody pr-0">
                  {{beadchip?.status}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>

      </div>
      <div *ngIf="beadChipViewSelected==false" class="col-9 p-0">
        <div class="col-10 p-0">
          <div class="col-6 pr-0 pb-0">
            <div class="col-12 flex p-0">
              <table aria-describedby="Processing table" id="processingTable" style="border: 1px solid black; width: 100%; height: 11.2em; table-layout: fixed;">
                <thead id="processingTableHeader">
                  <tr>
                    <th scope="col">Wash Beadchips</th>
                  </tr>
                </thead>
                <tbody id="processingTableBody">
                  <tr>
                    <td id="processingTableBody">

                      <div class="col-12 flex parent">
                          <div class="col-2 child22">
                            <button type="button" (click)="showChemicalPopup(false,'WASHING')" pButton class="buttonsRound1 downLoadButton"
                              label="LOT"></button>
                          </div>
                      </div>

                      <div class="col-12 flex parent" style="margin-top:0.2rem;">
                        <div class="col-8 child">
                          <button pButton label="Start Washing" (click)="saveBeadchipStatus('WASHING_STARTED', 0, 'WASHING', '', 0)"
                          class="buttonsRound startButton" [disabled]="disableButton(0, 'WASHING', '', 0)">
                          </button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('WASHING')">
                          {{getProcessStepStartTimestamp('WASHING') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepStartPuid('WASHING')}}
                        </div>
                      </div>
                      <div class="col-12 flex parent">
                        <div class="col-8 child" style="margin-bottom:0.2rem;">
                          <button pButton label="Complete Washing" (click)="saveBeadchipStatus('WASHING_COMPLETED', 1, 'WASHING', '', 0)"
                          class="buttonsRound endButton" [disabled]="disableButton(1, 'WASHING', '', 0)"></button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('WASHING')">
                          {{getProcessStepEndTimestamp('WASHING') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepEndPuid('WASHING')}}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table aria-describedby="Processing table" id="processingTable" style="border: 1px solid black; width: 100%; height: 11.4em; table-layout: fixed;">
                <thead id="processingTableHeader">
                  <tr>
                    <th scope="col">Assemble Flow-Through Chambers</th>
                  </tr>
                </thead>
                <tbody id="processingTableBody">
                  <tr>
                    <td id="processingTableBody">
                      
                      <div class="col-12 flex parent">
                        <div class="col-8 ui-inputgroup" style="padding-left:0%">
                          <button type="button" pButton class="LHbutton LHButton1" label="Liquid Handler"></button>
                          <input pInputText id="input" [(ngModel)]="extensionLiquidHandler" [value]="getProcessStepLiquidHandler('EXTENSION')" [disabled]="disableButton(0, 'EXTENSION', '', 0)"  class="SearchBox" size="30"/>
                        </div>
                        <div class="col-2"></div>
                        <div class="col-2 child3">
                          <button type="button" (click)="showChemicalPopup(false, 'EXTENSION')" pButton class="buttonsRound1 downLoadButton1"
                            label="LOT"></button>
                        </div>
                      </div>
                      
                      <div class="col-12 flex parent" style="margin-top:0.2rem;">
                        <div class="col-8 child">
                          <button pButton label="Start Extension" (click)="saveBeadchipStatus('EXTENSION_STARTED', 0, 'EXTENSION', '', 0)"
                          class="buttonsRound startButton" [disabled]="disableButton(0, 'EXTENSION', '', 0)"></button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('EXTENSION')">
                          {{getProcessStepStartTimestamp('EXTENSION') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepStartPuid('EXTENSION')}}
                        </div>
                      </div>
                      <div class="col-12 flex parent">
                        <div class="col-8 child" style="margin-bottom:0.5rem">
                          <button pButton label="Complete Extension" (click)="saveBeadchipStatus('EXTENSION_COMPLETED', 1, 'EXTENSION', '', 0)"
                          class="buttonsRound endButton" [disabled]="disableButton(1, 'EXTENSION', '', 0)"></button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('EXTENSION')">
                          {{getProcessStepEndTimestamp('EXTENSION') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepEndPuid('EXTENSION')}}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-6 pl-0 pb-0">
            <div class="col-12 flex p-0">
              <table aria-describedby="Processing table" id="processingTable" style="border: 1px solid black; width: 100%; height: 22.6em; table-layout: fixed;">
                <thead id="processingTableHeader">
                  <tr>
                    <th scope="col">Wash and Coat Beadchips</th>
                  </tr>
                </thead>
                <tbody id="processingTableBody">
                  <tr>
                    <td id="processingTableBody" style="margin-bottom:0.2rem">
                      <div class="col-12 flex parent">
                        <div class="col-2 child22">
                          <button type="button" (click)="showChemicalPopup(false,'COATING')" pButton class="buttonsRound1 downLoadButton"
                            label="LOT"></button>
                        </div>
                      </div>
                      <div class="col-12 flex parent" style="margin-top:0.2rem;">
                        <div class="col-8 child">
                          <button pButton label="Start Coating" (click)="saveBeadchipStatus('COATING_STARTED', 0, 'COATING', '', 0)"
                          class="buttonsRound startButton" [disabled]="disableButton(0, 'COATING', '', 0)"></button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('COATING')">
                          {{getProcessStepStartTimestamp('COATING') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepStartPuid('COATING')}}
                        </div>
                      </div>
                      <div class="col-12 flex parent">
                        <div class="col-8 child">
                          <button pButton label="Complete Coating" (click)="saveBeadchipStatus('COATING_COMPLETED', 1, 'COATING', '', 0)"
                          class="buttonsRound endButton" [disabled]="disableButton(1, 'COATING', '', 0)"></button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('COATING')">
                          {{getProcessStepEndTimestamp('COATING') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepEndPuid('COATING')}}
                        </div>
                      </div>
                      <div class="col-12 flex parent">
                        <div class="col-8 child">
                          <button pButton label="Beadchip Drying" style="background-color:darkviolet; " (click)="saveBeadchipStatus('BEADCHIP_DRYING', 2, 'COATING', 'BEADCHIP_DRYING', 0)"
                            class="buttonsRound startButton" [disabled]="disableButton(2, 'COATING', 'BEADCHIP_DRYING', 0)">
                          </button>
                        </div>
                        <div class="col-4 action-timer-div" *ngIf="isValidProcessStepAction('COATING', 'BEADCHIP_DRYING')">
                          <span class="action-timer-span">{{calculateRemainingTimeForAction('COATING', 'BEADCHIP_DRYING')}} </span>
                        </div>
                      </div>
                      <div class="col-12 flex parent">
                        <div class="col-8 child">
                          <button pButton label="Image Beadchip" style="background-color:darkviolet; " (click)="saveBeadchipStatus('BEADCHIP_IMAGED', 0, 'COMPLETED', 0)"
                            class="buttonsRound startButton" [disabled]="disableButton(0, 'COMPLETED', 'COMPLETED', 0)">
                          </button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('COMPLETED')">
                          {{getProcessStepStartTimestamp('COMPLETED') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepStartPuid('COMPLETED')}}
                        </div>
                      </div>
                      <div class="col-12 flex parent">
                        <div class="col-8 child" style="margin-bottom:0.5rem">
                          <button pButton label=" Resultfiles Sent" class="buttonsRound otherbutton" (click)="saveBeadchipStatus('COMPLETED', 1, 'COMPLETED', '', 0)"
                          [disabled]="disableButton(1, 'COMPLETED', 'COMPLETED', 0)">
                          </button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('COMPLETED')">
                          {{getProcessStepEndTimestamp('COMPLETED') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepEndPuid('COMPLETED')}}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-12 flex pt-0">
            <div class="col-12 flex p-0">
              <table aria-describedby="Processing table" id="processingTable" style="border: 1px solid black; width: 100%; height: 9em; table-layout: fixed;">
                <thead id="processingTableHeader">
                  <tr>
                    <th scope="col">Last Updated</th>
                  </tr>
                </thead>
                <tbody id="processingTableBody">
                  <tr>
                    <td id="processingTableBody">
                      <table class="last-updated-table">
                        <tr *ngFor="let updatedPlate of lastUpdatedBeadChips1; let i=index">
                          <td>{{updatedPlate.BeadChipId}}</td>
                          <td>{{lastUpdatedBeadChips2[i].BeadChipId}}</td>
                          <td>{{lastUpdatedBeadChips3[i].BeadChipId}}</td>
                        </tr>
                        <tr>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="beadChipViewSelected==true" class="col-9 p-0">
        <app-ma-beadchip-view [selectedBeadchipData]="selectedBeadChipPlate"></app-ma-beadchip-view>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Multiple BeadChips Update" [(visible)]="showConfirmBeadChipsPopup"  showEffect="fade" position="top"
    [modal]="true" [style.width]="'325px'" [contentStyle]="{'max-height':'70vh'}">
  <div class="content-in-multi-update-popup">
    <table id="scanTable" aria-describedby="View Plates" class="table">
      <tr>
        <input pInputText name="plateId" [(ngModel)]="enteredBeadChipId" id="popup-beadchipid" (keydown.enter)="checkBeadChip()"
          [placeholder]="multiUpdateInputLabel" />
      </tr>
      <tr *ngFor="let beadChip of multiUpdateBeadChipList; let myIndex=index;">
        <input pInputText name="plateId" [value]="beadChip"  id="plateid" readonly />
        <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteBeadChipFromMultiUpdateList(myIndex)"></button>        
      </tr>
    </table>
  </div>
    <div>
      <button pButton [label]="multiUpdateStatusLabel" (click)="updateMultiBeadChips()" class="buttonsRound multi_UpdateButton" [ngClass]="multiUpdateButtonStyleClass"
        [disabled]="multiUpdateBeadChipList.length ==0">
      </button>
    </div>
</p-dialog>

<p-dialog header="Chemicals" [(visible)]="showDialogue"  [focusOnShow]="true" [modal]="true" [style.width]="'800px'" position="top" (onHide)="hideChemicalDialog(selectedBeadChipPlate)">
  <app-ma-chemicals-popup [selectedPlate]="selectedBeadChipPlate" [selectedBeadChip]="selectedBeadChip" [selectedProcessStep]="selectedProcessStep" [processStepChemicals]="processStepChemicals" [noChemicalEdit]="noChemicalEdit" 
    [multiChemicals]="multiChemicalEdit" [plateids]="chemicalsBeadChipids" [isPlate]="true" [dialogOpen]="showDialogue" (backButtonEmitter)="hideChemicalDialog($event)"></app-ma-chemicals-popup>
</p-dialog>

<p-dialog header="Add Comments" [(visible)]="showMultipleCommentDialog" [modal]="true" position="top" [contentStyle]="{'max-height':'70vh'}">
  <div class="col-12 flex mt-0" id="commentTextAreDiv">
    <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..." [(ngModel)]="newMultiComment"></textarea>
  </div>
  <div class="col-12 flex mt-2 addCommentButton">
    <button pButton label="Add Comment" [disabled]="(newMultiComment == null || newMultiComment.trim() == '')" (click)="saveMultiComment()"></button>
  </div>
</p-dialog>

<p-dialog header="{{selectedBeadChipPlate?.plateID + ' Comments'}}" [(visible)]="showCommentDialog" [modal]="true" position="top" [contentStyle]="{'max-height':'70vh'}">
  <app-ma-comments-popup [selectedPlateID]="selectedPlateID" [selectedBeadchipStatus]="selectedBeadchipStatus"  [plateCommentList] = "plateCommentsList"  [beadChipCommentsDisplayMap]="beadChipCommentsDisplayMap" [beadChipCommentsMap]="beadChipCommentsMap" [beadChipID] ="selectedBeadChipPlate?.plateID" (backButtonEmitter)="hideDialog()"></app-ma-comments-popup>
</p-dialog>

